<script setup lang="ts">
import { XMarkIcon } from "@heroicons/vue/24/outline";
import SearchBarInputIconButton from "./SearchBarInputIconButton.vue";
</script>

<template>
  <SearchBarInputIconButton class="rounded-r">
    <XMarkIcon class="w-6 h-6" />
  </SearchBarInputIconButton>
</template>
